module.exports = __webpack_public_path__ + "img/logo.6d1dd5e6.svg";